import { observer } from 'mobx-react';

import { useStores } from '@/hooks/use-stores';

const Auth = observer(({ permission, children }) => {
  const { permissionStore } = useStores();

  return permissionStore.isAuth(permission) ? children : null;
});

export default Auth;
